import { z } from 'zod'

/**
 * No eval in the browser.
 *
 * The production CSP (apps/web/nginx.conf) is `script-src 'self'`, with no 'unsafe-eval'. zod 4
 * compiles fast validators with `new Function` when it can, and finds out by trying
 * `Function("")` once. Behind that policy the attempt throws; zod catches it and falls back to
 * interpreting, so parsing works. But the browser still reports a CSP violation for it on every
 * page load, and a real violation drowns among those false ones. `jitless` skips the attempt.
 *
 * Imported first in main.tsx, before any schema is built or parsed. The dev server sends no CSP,
 * which is why only the production build showed it.
 */
z.config({ jitless: true })
